export class Helper {


	static updateModel(model, event) {
		let value = event.target.value;
		if (event.target.type == "checkbox") {
			value = event.target.checked;
		}

		let keys = event.target.name.split(".");

		model = Functions._updateModelInner(model, keys, value)

		return model
	}

	static _updateModelInner(model, keys, value) {
		let key = keys[0];

		if (keys.length == 1) {
			model[key] = value;
		} else {
			if (model[key] == null) {
				model[key] = {};
			}
			keys.splice(0, 1);
			model[key] = Functions._updateModelInner(model[key], keys, value);
		}

		return model;
	}

	static lowerProps(obj) {
		if (!obj)
			return null;
		var keys = Object.keys(obj);
		var n = keys.length;
		while (n--) {
			var key = keys[n]; // "cache" it, for less lookups to the array
			var newKey = key.charAt(0).toLowerCase() + key.slice(1);

			if (key !== newKey) { // might already be in its lower case version
				obj[newKey] = obj[key] // swap the value to a new lower case key
				delete obj[key] // delete the old key
			}
		}
		return (obj);
	}

	static capitalizeProps(obj) {
		if (!obj)
			return null;
		var keys = Object.keys(obj);
		var n = keys.length;
		while (n--) {
			var key = keys[n]; // "cache" it, for less lookups to the array
			var newKey = key.charAt(0).toUpperCase() + key.slice(1);

			if (key !== newKey) { // might already be in its lower case version
				obj[newKey] = obj[key] // swap the value to a new lower case key
				delete obj[key] // delete the old key
			}
		}
		return (obj);
	}


	static groupBy(xs, f) {
		return xs.reduce((r, v, i, a, k = f(v)) => ((r[k] || (r[k] = [])).push(v), r), {});
	}

	static getCookie(name) {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	static getUrlPatram(name) {
		const queryString = window.location.search;
		const urlParams = new URLSearchParams(queryString);
		return urlParams.get(name);
	}
}